export default __webpack_public_path__ + "static/media/icon.7d0e7c76.svg";